module.exports = __webpack_public_path__ + "static/media/icon_rut.da65b955.svg";